/** @jsxImportSource @emotion/react */
import React, { SetStateAction } from "react";
import { ItemType } from "../../pages/form-builder";
interface Props {
  item: ItemType;
  setItem: (update: SetStateAction<ItemType>) => void;
  isSelected?: boolean;
  isPreview?: boolean;
}

export default function FormBuilderHTML(props: Props) {
  const { item } = props;

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: item.state }} />
    </div>
  );
}
